module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f466-1f3ff.0a6795ad.svg";